import { Component, ViewChild } from '@angular/core';
import {
  AbstractControlOptions,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { RecaptchaComponent } from 'ng-recaptcha';
import { Subject, takeUntil } from 'rxjs';
import { IError, IResponse } from 'src/app/_types/common.types';
import { AuthService } from 'src/app/services/auth.service';
import { FormService } from 'src/app/shared/services/form.service';

import { matchPasswordValidator } from 'src/app/validators/match_password';
import {
  formNoWhitespaceValidator,
  patterns,
} from 'src/app/validators/pattern_validation';

@Component({
  selector: 'app-company-detail-form',
  templateUrl: './company-detail-form.component.html',
  styleUrls: ['./company-detail-form.component.scss'],
})
export class CompanyDetailFormComponent {
  form!: FormGroup;
  isVerifiedCaptcha: boolean = true;
  captchaToken: string | undefined = undefined;
  private unsubscribe$ = new Subject<void>();

  @ViewChild('captchaRef')
  public recaptchaRef!: RecaptchaComponent;

  constructor(
    private formBuilder: FormBuilder,
    private formService: FormService,
    private authService: AuthService
  ) {
    this.form = this.formBuilder.group(
      {
        company_name: [
          '',
          [
            Validators.required,
            Validators.pattern(patterns.COMPANY_NAME.regex),
          ],
        ],
        first_name: [
          '',
          [Validators.required, Validators.pattern(patterns.FIRST_NAME.regex)],
        ],
        last_name: [
          '',
          [Validators.required, Validators.pattern(patterns.LAST_NAME.regex)],
        ],
        telephone_number: [
          '',
          [
            Validators.required,
            Validators.pattern(patterns.CORPORATE_TELEPHONE_NUMBER.regex),
          ],
        ],
        email: [
          '',
          [Validators.required, Validators.pattern(patterns.EMAIL.regex)],
        ],
        password: ['', [Validators.required]],
        confirm_password: [
          '',
          [Validators.required, matchPasswordValidator('password')],
        ],
        industry: ['', [Validators.pattern(patterns.INDUSTRY.regex)]],
        number_of_drivers: [
          ,
          [
            Validators.minLength(0),
            Validators.pattern(/^[1-9]\d*$/),
            Validators.maxLength(5),
          ],
        ],
        isTermsAndCondition: [false, Validators.requiredTrue],
      },
      { validators: [formNoWhitespaceValidator] } as AbstractControlOptions
    );

    // Subscribe to password changes
    this.form.get('password')?.valueChanges.subscribe(() => {
      this.form.get('confirm_password')?.updateValueAndValidity();
    });
  }

  ngOnInit(): void {}

  getErrorMessage(controlName: string): string {
    return this.formService.getErrorMessage(controlName, this.form);
  }

  checkUnique(controlName: string) {
    const control = this.form.get(controlName);
    if (control && control.value) {
      // Make API call to check control uniqueness
      this.authService
        .checkEmailUnique({ [controlName]: control.value })
        .subscribe({
          next: (response: Partial<IResponse>) => {
            // If email is not unique, add error to the form control
            if (!response.success) {
              control.setErrors({ notUnique: true });
            }
          },
          error: (error: Partial<IError>) => {
            console.log('Inside error======>>', error);
          },
        });
    }
  }

  onCaptchaResolved(token: string | null) {
    if (token !== null) {
      this.authService
        .validateCaptchaToken(token)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: (response: IResponse) => {
            if (response.success) {
              this.isVerifiedCaptcha = true;
            }
          },
          error: (error) => {
            this.isVerifiedCaptcha = false;
            this.recaptchaRef.reset();
            console.log('Error while validating captcha', error);
          },
        });
    }
  }

}
